import React, { useRef } from "react";

import MainPage from "../ui/mainPage/MainPage";
import Layout from "../components/Layout";

const MainPageTemplate = (props) => {
  const { pageContext } = props;
  const { recentArticles, popularArticles, speciesOptions, news } = pageContext;

  const refs = {
    popularArticlesRef: useRef(),
    recentArticlesRef: useRef(),
    aboutRef: useRef(),
    authorsRef: useRef(),
    reviewersRef: useRef(),
    contactRef: useRef(),
    speciesRef: useRef(),
    partnersRef: useRef(),
    publishRef: useRef(),
    newsRef: useRef(),
  };

  const main = (
    <MainPage
      recent={recentArticles}
      popular={popularArticles}
      refs={refs}
      speciesOptions={speciesOptions}
      news={news}
    />
  );

  return <Layout children={main} refs={refs} main />;
};

export default MainPageTemplate;
